import { createBrowserHistory } from "history";

export const routeHistory = createBrowserHistory();

export const goTo = (path: string, state?: Record<string, unknown>): void =>
	routeHistory.push(path, state);
